export const getIsRequestingPayment = (store: Store) => store.payments.isRequestingPayment;
